import React from "react";
import SurveyEmbed from "../components/survey/SurveyEmbed";

const SurveyPage = () => {
  return (
    <div className="survey-page">
      <SurveyEmbed />
    </div>
  );
};

export default SurveyPage;
